export default __webpack_public_path__ + "static/media/801.63a116eb.png";